<template>
  <div class="main" :class="theme == 2 ? 'bg000' : 'bgfff'">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!-- <p>刷新次数: {{ count }}</p> -->
      <div v-if="list.length > 0" style="padding-bottom:0.5rem">
        <van-list v-model="loading" :finished="finished" @load="onLoad">
          <div
            class="item"
            v-for="(item, i) in list"
            :key="i"
            @click="goOrderDetail(item)"
          >
            <div class="item-top">
              <p>
                <span
                  class="fs26"
                  :class="theme == 2 ? 'color99A1B4' : 'color333'"
                  >订单号：{{ item.orderNo }}</span
                ><span class="fs26"
                  ><img src="../../assets/icon8.png" alt=""
                /></span>
              </p>
              <p class="fs28 btn colorFA3B32">
                {{
                  item.state == 0
                    ? "未支付"
                    : item.state == 1
                    ? "已支付"
                    : item.state == 2
                    ? "已退款"
                    : item.state == 3
                    ? "已到期"
                    : item.state == 4
                    ? "部分支付"
                    : item.state == 5
                    ? "部分退款"
                    : item.state == 6
                    ? "已取消"
                    : ""
                }}
              </p>
            </div>
            <div class="item-name">
              <p
                class="fs30 fw500"
                :class="theme == 2 ? 'colorF0F1F5' : 'color394259'"
                style="padding-top: 0.19rem"
              >
                <span>{{ item.productName }}</span
                ><span>￥{{ item.payMoney }}</span>
              </p>
              <p class="fs28" style="padding-top: 0.12rem; color: #9097a5">
                <span
                  >开通周期：<i
                    :class="theme == 2 ? 'colorF0F1F5' : 'color394259'"
                    >{{ item.dateTypeMsg }}</i
                  ></span
                ><span>{{ item.state == 1 ? "实付" : "应付" }}</span>
              </p>
            </div>
            <!-- <div class="item-bottom" v-if="item.state == 1"></div> -->
            <!-- <div class="item-bottom"></div>
            <div class="item-bottom"></div> -->
            <div
              class="item-bottom"
              v-if="item.state == 0 && item.djs != '结束'"
            >
              <p class="item-time">
                <img src="../../assets/icon9.png" alt="" />
                <span class="colorFA3B32">{{ item.djs }} </span>
                <span class="color9097A5"> 后关闭</span>
              </p>
              <p class="btns">
                <span class="quxiao" @click.stop="update(6, item)"
                  >取消订单</span
                >
                <span class="zhifu">立即支付</span>
              </p>
            </div>
            <div class="item-bottom" v-if="item.state == 4">
              <p class="item-time">
                <!-- 剩余未支付¥546.88 -->

                <span class="color9097A5"> 剩余未支付</span>
                <span class="colorFA3B32"
                  >¥{{ (item.payMoney - item.prepaidMoney).toFixed(2) }}</span
                >
              </p>
              <p class="btns">
                <span class="zhifu">立即支付</span>
              </p>
            </div>
            <div
              class="item-bottom"
              style="justify-content: flex-end"
              v-if="item.state == 6 || item.state == 3"
            >
              <p class="btns">
                <span class="quxiao" @click.stop="update(9, item)"
                  >删除订单</span
                >
              </p>
            </div>
          </div>
        </van-list>
      </div>
      <wushuju v-else v-show="show" :theme="theme"></wushuju>
      <!-- <div class="wushuju" v-else>
        <img src="../../assets/kjhf/icon10.png" alt="" />
        <p>暂无数据</p>
      </div> -->
    </van-pull-refresh>
  </div>
</template>

<script>
import api from "@/api/mall";
import { MinutesTest, timestamp } from "@/utils/time";
import wushuju from "@/components/wushuju";
import { PullRefresh, List, Toast, Dialog } from "vant";
import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
} from "@/utils/utility";
var userAgent = getBrowserUserAgent();
var dsBridge = require("dsbridge");
import store from "@/store";
function InitTime(endtime) {
  var dd,
    hh,
    mm,
    ss = null;
  var time = endtime - new Date().getTime();
  if (time > 0) {
    hh = Math.floor((time / 60 / 60) % 24);
    mm = Math.floor((time / 60) % 60);
    ss = Math.floor(time % 60);
    if (hh <= 9) {
      hh = "0" + hh;
    }
    if (mm >= 0 && mm <= 9) {
      mm = "0" + mm;
    }
    if (ss >= 0 && ss <= 9) {
      ss = "0" + ss;
    }
    var str = hh + ":" + mm + ":" + ss;
    return str;
  } else {
    return "结束";
  }
}
export default {
  components: {
    [Toast.name]: Toast,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Dialog.name]: Dialog,
    wushuju,
  },
  props:{
    theme:Number
  },
  data() {
    return {
      list: [],
      isLoading: false,
      loading: false,
      finished: true,
      page: 1,
      show: false,
      total: 0,
      
    };
  },
  created() {
    if (sessionStorage.getItem("theme") == 2) {
      this.theme = 2;
    } else {
      this.theme = 1;
    }
    this.getList();
  },
  mounted() {
    setInterval(() => {
      for (var i in this.list) {
        var aaa = parseInt(this.list[i]["endtime"]);
        var bbb = new Date().getTime();
        var rightTime = aaa - bbb;

        if (rightTime > 0) {
          var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
          var mm = Math.floor((rightTime / 1000 / 60) % 60);
          var ss = Math.floor((rightTime / 1000) % 60);
          if (hh <= 9) {
            hh = "0" + hh;
          }
          if (mm >= 0 && mm <= 9) {
            mm = "0" + mm;
          }
          if (ss >= 0 && ss <= 9) {
            ss = "0" + ss;
          }
          this.list[i]["djs"] = hh + ":" + mm + ":" + ss;
        } else {
          this.list[i]["djs"] = "结束";
          if (this.list[i].state == 0) {
            this.list[i].state = 6;
          }
        }
      }
    }, 1000);

    var that = this;
    if (userAgent.android) {
      dsBridge.register("changeTheme", function (responseData) {
        responseData = JSON.parse(responseData);
        that.theme = responseData;
        sessionStorage.setItem("theme", responseData);
         that.$emit("changeTheme", that.theme);
      });
    } else {
      connectWebViewJavascriptBridge((bridge) => {
        var that = this;
        window.WebViewJavascriptBridge.registerHandler(
          "changeTheme",
          function (responseData) {
            responseData = JSON.parse(responseData);
            that.theme = responseData;
            sessionStorage.setItem("theme", responseData);
             that.$emit("changeTheme", that.theme);
          }
        );
      });
    }
  },

  methods: {
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        this.page++;

        // 加载状态结束
        // console.log(this.page);
        this.loading = false;
        this.getList();

        // 数据全部加载完成
      }, 1000);
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.page = 1;
        this.getList();
      }, 1000);
    },
    update(state, item) {
      var message = "";
      if (state == 6) {
        message = "确定取消该订单吗？";
      } else {
        message = "确定删除该订单吗？";
      }
      Dialog.confirm({
        title: "提示",
        message: message,
      })
        .then(() => {
          // on confirm
          let params = {
            state: state,
            orderNo: item.orderNo,
          };
          api.getOrderUpdateState(params).then((res) => {
            if (res.code == 200) {
              if (state == 6) {
                Toast("取消成功");
              } else {
                Toast("删除成功");
              }
              this.page = 1;
              this.getList();
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    goOrderDetail(item) {
      let query = {
        orderNo: item.orderNo,
      };
      this.$router.push({ path: "/orderDetail", query: query });
    },

    getList() {
      let params = {
        page: this.page,
        pageSize: 10,
        type: 1,
      };
      api.getOrderQueryList(params).then((res) => {
        this.show = true;
        if (res.code == 200) {
          this.total = res.data.total;
          var list = [];
          res.data.records.forEach((p) => {
            if (p.state == 0) {
              p.endtime = MinutesTest(p.ctimeT);
              p.stime = timestamp(p.ctimeT);
              p.djs = InitTime(p.endtime);
            }

            list.push(p);
          });
          if (this.page == 1) {
            this.list = [];
          }
          this.list = this.list.concat(list);
          if (this.list.length >= this.total) {
            this.finished = true;
            this.title = "没有更多了";
          } else {
            this.finished = false;
            this.title = "";
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  // min-height: calc(100vh - 44px);
}
.bgfff {
  background: #f4f5f7;
   .item{
    box-shadow: 0px 0.02rem 0.08rem 0px rgba(220, 221, 220, 0.2);
  }
}
.item {
  margin: 0.24rem 0.24rem 0 0.24rem;
  width: 7.02rem;
  min-height: 2.3rem;
  background: #fff;
  border-radius: 0.14rem;
  .item-top {
    padding: 0 0.24rem;
    height: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      display: flex;
      align-items: center;
    }
    img {
      width: 0.2rem;
      height: 0.2rem;
      margin-left: 0.14rem;
    }
  }
  .item-name {
    height: 1.33rem;
    padding: 0 0.24rem;
    p {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .item-bottom {
    height: 1rem;
    margin: 0 0.24rem;
    border-top: 0.02rem solid #eeeff4;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .btns {
      display: flex;
      justify-content: flex-end;
      span {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.28rem;
      }
      .quxiao {
        width: 1.62rem;
        height: 0.54rem;
        background: #ffffff;
        border-radius: 0.3rem;
        border: 0.02rem solid #cccccc;

        color: #5d667a;
      }
      .zhifu {
        color: #ffffff;
        width: 1.62rem;
        margin-left: 0.24rem;
        height: 0.54rem;
        background: #fa3b32;
        border-radius: 0.3rem;
        border: 0.02rem solid #fa3b32;
      }
    }
  }
}
.item-time {
  display: flex;
  align-items: center;
  img {
    width: 0.26rem;
    height: 0.26rem;
    margin-right: 0.08rem;
  }
  span {
    margin-right: 0.08rem;
  }
}
.bg000 {
  background: #000;
  .item {
    background: #121620;
  }
  .item-bottom {
    border-top: 0.02rem solid #262e41;
    .btns .quxiao {
      background: #1d2534;
      color: #f0f1f5;
      border: 0.02rem solid #1d2534;
    }
  }
}
</style>